import localStorage from 'store'
import socket from '@/libs/socket'
import * as types from '../mutation-types'

const debug = process.env.NODE_ENV !== 'production'

const UUID_KEY = 'socket_uuid'

const state = {
  connected: false,
  uuid: null,
  subscriptions: []
}

const getters = {
  isSocketConnected: () => {
    return state.connected
  },
  isSubscribed: (state) => (message) => {
    return findSubscription(state, message) >= 0
  },
  socketUUID: (state) => {
    return state.uuid || localStorage.get(UUID_KEY)
  }
}

const actions = {
  subscribe ({ commit }, message) {
    commit(types.SOCKET_SUBSCRIBE, message)
  },
  unsubscribe ({ commit }, message) {
    commit(types.SOCKET_UNSUBSCRIBE, message)
  },
  resubscribe ({ commit }) {
    state.subscriptions.forEach((sub) => {
      commit(types.SOCKET_UNSUBSCRIBE, sub)
      socket.subscribe(sub.type, sub.id, sub.childType)
    })
  },
  socketMessage ({ commit, dispatch }, message) {
    const payload = message.payload || {}

    if (payload.action === 'set' && payload.type === 'uuid') {
      commit(types.SOCKET_UUID, payload.uuid)
      if (!localStorage.get(UUID_KEY)) {
        localStorage.set(UUID_KEY, payload.uuid)
        dispatch('logUserHubspotID', { uuid: payload.uuid })
      }
    }
  }
}

const mutations = {
  [types.SOCKET_ONOPEN] (state, event) {
    state.connected = true
    socket.connected()
  },
  [types.SOCKET_ONCLOSE] (state, event) {
    state.connected = false
    socket.connect()
  },
  [types.SOCKET_ONERROR] (state, event) {
    if (debug) {
      console.error(state, event)
    }
  },
  [types.SOCKET_ONMESSAGE] (state, message) {
    // messages should be handled through the action socketMessage
  },
  [types.SOCKET_SUBSCRIBE] (state, message) {
    const i = findSubscription(state, message)
    if (i === -1) {
      state.subscriptions.push(message)
    }
  },
  [types.SOCKET_UNSUBSCRIBE] (state, message) {
    const i = findSubscription(state, message)
    if (i >= 0) {
      state.subscriptions.splice(i, 1)
    }
  },
  [types.SOCKET_UUID] (state, uuid) {
    state.uuid = uuid
  },
  [types.RESET_ON_LOGOUT] (state) {
    state.connected = false
    state.uuid = null
    state.subscriptions = []
  }
}

const findSubscription = function (state, message) {
  const key = `${message.type}-${message.id}-${message.childType}`
  let index = -1
  for (let i = 0; i < state.subscriptions.length; i++) {
    const sub = state.subscriptions[i]
    const subKey = `${sub.type}-${sub.id}-${sub.childType}`
    if (key === subKey) {
      index = i
      break
    }
  }
  return index
}

export default {
  state,
  getters,
  actions,
  mutations
}
